/** 格式化倒计时 */
export const formattCountdown = (countdown: number) => {
  const minutes = Math.floor(countdown / 60)
  const seconds = countdown % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
